const AURA_VIDEO_REF_RE = /^[A-Za-z0-9_-]{1,64}$/;

const AURA_VIDEO_PATH_PATTERNS: readonly RegExp[] = [
  /^\/api\/link\/video\/([^/?#]+)\/?$/,
  /^\/link\/video\/([^/?#]+)\/?$/,
  /^\/video\/([^/?#]+)\/?$/,
  /^\/api\/embed\/([^/?#]+)\/?$/,
];

export function parseAuraVideoRefFromUrl(
  rawUrl: string,
  embedOrigin: string | undefined,
  pasteAllowedHostnames?: readonly string[] | undefined
): string | null {
  if (!embedOrigin) {
    return null;
  }

  let embedHost: string;
  try {
    embedHost = new URL(embedOrigin).hostname.toLowerCase();
  } catch {
    return null;
  }
  if (!embedHost) {
    return null;
  }

  const pasteHostSet =
    pasteAllowedHostnames && pasteAllowedHostnames.length > 0
      ? new Set(pasteAllowedHostnames.map((h) => h.toLowerCase()))
      : new Set([embedHost]);

  let parsed: URL;
  try {
    parsed = new URL(rawUrl);
  } catch {
    return null;
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    return null;
  }
  if (parsed.username || parsed.password) {
    return null;
  }
  if (!pasteHostSet.has(parsed.hostname.toLowerCase())) {
    return null;
  }

  for (const pattern of AURA_VIDEO_PATH_PATTERNS) {
    const match = pattern.exec(parsed.pathname);
    if (!match) {
      continue;
    }
    let ref: string;
    try {
      ref = decodeURIComponent(match[1]);
    } catch {
      return null;
    }
    return AURA_VIDEO_REF_RE.test(ref) ? ref : null;
  }

  return null;
}

export function buildAuraEmbedSrc(
  videoRef: string,
  embedOrigin: string | undefined
): string | null {
  if (typeof videoRef !== 'string' || !embedOrigin || !AURA_VIDEO_REF_RE.test(videoRef)) {
    return null;
  }
  return `${embedOrigin.replace(/\/+$/, '')}/api/embed/${encodeURIComponent(videoRef)}`;
}
